





































































import { Component, Vue, Watch } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import SectionHeader from './SectionHeader.vue';
import {
  IOfferRecommendation,
  SmartBusinessSignupData
} from '@/models/smart-business-signup';
import eventBus from '@/utils/eventBus';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import LazyImage from '@/componentsV2/atoms/LazyImage/LazyImage.vue';
import { Checkbox } from '@/components/atoms';
import segmentIo from '@/utils/segment.io';
import OfferTypeTag from '@/components/molecules/OfferTypeTag/OfferTypeTag.vue';

const ON_CHANGE_KEY = 'offersRecommendation';

@Component({
  components: {
    Typography,
    SectionHeader,
    LazyImage,
    Checkbox,
    OfferTypeTag
  }
})
export default class Offers extends Vue {
  selectedOfferIndex = 0;

  formData = this.smartBusinessSignupData.offersRecommendation;

  get smartBusinessSignupData(): SmartBusinessSignupData {
    return this.$store.getters['businessOnboarding/getSmartBusinessSignup'];
  }

  get offers() {
    return this.formData.offers;
  }

  get isAllOffersDisabled() {
    return this.formData.offers.filter(offer => offer.enabled).length === 0;
  }

  @Watch('formData', { deep: true })
  onChangeEmit() {
    this.$emit('onChange', this.formData, ON_CHANGE_KEY);
  }

  changedEnabledOffer(offer: IOfferRecommendation, checked: boolean) {
    segmentIo.track('AI Sign Up | Offer Selected', {
      Selected: checked,
      Offer: offer
    });
    this.formData.offers = this.formData.offers.map(item => {
      if (item.title === offer.title) {
        return {
          ...item,
          enabled: checked
        };
      }
      return item;
    });
  }

  handleEditOffer(index: number) {
    this.selectedOfferIndex = index;
    this.editOffer();
  }

  changeEnable(value: boolean) {
    if (this.isAllOffersDisabled) return;

    segmentIo.track('AI Sign Up | Offer Activation Toggle', {
      Enabled: value
    });

    this.formData.enabled = value;
  }

  editOffer(image?: any) {
    let offer = this.offers[Number(this.selectedOfferIndex)];

    if (!offer) return;

    if (image) {
      offer = {
        ...offer,
        image
      };
    }
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'editAIOffer',
        hideCancelButton: true,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false
      }),
      {
        offer,
        index: this.selectedOfferIndex,
        editOffer: (offerEdited: any) => {
          this.formData.offers = this.formData.offers.map(
            (offer: IOfferRecommendation, index: number) => {
              if (index === this.selectedOfferIndex)
                return {
                  ...offer,
                  ...offerEdited,
                  image: {
                    url: offerEdited.imageSrc,
                    id: offerEdited.imageId
                  }
                };
              return offer;
            }
          );
        }
      }
    );
  }

  mounted() {
    eventBus.$on('updateOfferImage', this.editOffer);
  }

  beforeDestroy() {
    eventBus.$off('updateOfferImage', this.editOffer);
  }
}
